import { ROUTE_PATH } from "common/constants/sm-constants";
import { GridMetaModel, Headers } from "common/models/utility-models/meta-model";

export class InvitedGridMetaModel extends GridMetaModel<Headers> {
    constructor() {
      super(
        'Invited',
        ROUTE_PATH.invited,
        ROUTE_PATH.viewTrainers,
        false,
      false,
      8,
      false,
      false,
      ['student_name'],
      false,
      [],
      { isDownloadExcel: false, excelFileName: '', btnLabel: '', headers: [] },
      false,
      null,
      false,
      true,
      false,
      '',
      { evalKey: 'wantToDelete', evalParam: [0], decisiveParam: true },
      false,
      '',
      null,
      null,
      true,
      true,
      true,
      [],
      false,
      {
        isExtraActions: false,
        btnLabel: '',
        selectOptions: [],
        selectedValue: '',
        isPreviewBtn: false,
        previewBtnLabel: '',
      },
      {
        isCheckboxEmit: false,
        emitKey: 'id',
        checkedKey: '',
        valueKey: '',
      },
      {
        isDownload: false,
        key: '',
        valueKey: '',
      },
      {
        isTabStatus: false,
        label: '',
        isChecked: false,
      },
      false,
      true,
      {
        isPrimary: true,
        isDanger: false,
      },
      '',
      { value: '', isVisible: false },
      false,
      false,
      false
    );
  }
  
    prepareHeaderList(): Headers[] {
      const headers: Headers[] = [];
      const studentName = new Headers(
        'Student Name',
        'student_name',
        false,
        true,
        'text'
      );
     
  
      const rating = new Headers(
        'Rating from Student',
        'student_ratings',
        false,
        true,
        'rating'    
      );
      const feedbackToAdmin = new Headers(
        'Feedback from Admin',
        'student_feedback',
        false,
        true,
        'text',
        '0'
      );
      const feedbackFromStudent = new Headers(
        'Feedback from Student',
        'student_feedback',
        false,
        true,
        'text'
      );
      const feedbackToStudent = new Headers(
        'Feedback To Student',
        'trainer_feedback_to_student',
        false,
        true,
        'text',
        '0'
      );
      headers.push(studentName);
      headers.push(rating);
      headers.push(feedbackFromStudent);
      headers.push(feedbackToStudent);
      headers.push(feedbackToAdmin);
  
      return headers;
    }
  }